import { useI18n, LANGUAGES } from "@/lib/i18n";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex gap-1" data-testid="lang-switcher">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`brutal-border px-2 py-1 font-mono text-[11px] uppercase tracking-widest ${
            lang === l.code ? "bg-black text-white" : "bg-white text-black"
          }`}
          title={l.code === "sv" ? "Svenska" : "English"}
        >
          {l.flag} {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
